import React, { useEffect, useState } from "react";
import { InputLabel } from "@mui/material";
import { Card, CardBody, Col, Row } from "reactstrap";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { InputLabelStyle } from "views/pages/manage/common/form-fields-mui/ASelect";
import CommonInput from "views/pages/manage/common/formFeilds/input/commonInput";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";

const modalStyle = {
  position: "absolute",
  zIndex: "75",
  top: "2rem",
  right: "5rem",
  width: "60%",
  height: "100%",
};

const inputHeight = { height: "42px" };

const FilterForm = ({ formModal = {}, inputHandler, dropdowns }) => {
  const columnSize = 12;
  const [localForm, setLocalForm] = useState(formModal); 
  

  console.log(localForm, dropdowns,  "localForm")

  useEffect(() => {
    setLocalForm(formModal); // Sync initial props on mount or update
  }, [formModal]);

  const handleLocalChange = (value, field) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }));
  };

  const applyFilter = () => {
    inputHandler(localForm); // Send updated state back to parent
  };

  return (
    <div>
      <Card style={{ width: "342px", marginBottom: "0px" }}>
        <CardBody style={{ paddingTop: ".5rem", paddingBottom: ".5rem" }}>
          <h4 style={{ color: "black" }}>Filter by</h4>

          <Row>
            <Col md={columnSize}>
              <AAutoComplete
                label="Branch"
                currentValue={localForm.businessArea}
                items={dropdowns?.businessAres}
                handleChange={(value) => handleLocalChange(value, "businessArea")}
                height={inputHeight.height}
                isMulti={false}
              />
            </Col>
          </Row>

          <Row>
            <Col md={columnSize}>
              <AAutoComplete
                label="Term"
                currentValue={localForm.term}
                items={dropdowns?.term}
                handleChange={(value) => handleLocalChange(value, "term")}
                height={inputHeight.height}
                isMulti={false}
              />
            </Col>
          </Row>

          <Row>
            <Col md={columnSize}>
              <AAutoComplete
                label="Academic Group"
                currentValue={localForm.academicGroup}
                items={dropdowns?.stream}
                handleChange={(value) => handleLocalChange(value, "academicGroup")}
                height={inputHeight.height}
                isMulti={false}
              />
            </Col>
          </Row>

          <Row>
            <Col md={columnSize}>
              <AAutoComplete
                label="Course ID"
                currentValue={localForm.courseId}
                items={dropdowns?.courseIds}
                handleChange={(value) => handleLocalChange(value, "courseId")}
                height={inputHeight.height}
                isMulti={false}
              />
            </Col>
          </Row>

          <Row>
            <Col md={columnSize}>
              <AAutoComplete
                label="Career"
                currentValue={localForm.academicCareer}
                items={dropdowns?.academicCareer}
                handleChange={(value) => handleLocalChange(value, "academicCareer")}
                height={inputHeight.height}
                isMulti={false}
              />
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <InputLabel style={InputLabelStyle}>
                Registration start from
              </InputLabel>
            </Col>
            <Col md={12}>
              <CommonInput
                type="datePicker"
                mandatory
                placeHolder="From"
                value={localForm.registrationStartDate}
                onChange={(value) =>
                  handleLocalChange(new Date(value), "registrationStartDate")
                }
              />
            </Col>
          </Row>

          <Row style={{ marginTop: "-24px" }}>
            <Col md="12">
              <InputLabel style={InputLabelStyle}>
                Registration start to
              </InputLabel>
            </Col>
            <Col md={12}>
              <CommonInput
                type="datePicker"
                mandatory
                placeHolder="To"
                value={localForm.registrationEndDate}
                onChange={(value) =>
                  handleLocalChange(new Date(value), "registrationEndDate")
                }
              />
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <AButton
                className="btn-left-0"
                updatedStyle={{ width: "100%" }}
                variant="primary_filled"
                onClick={applyFilter}
              >
                Apply filter
              </AButton>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default FilterForm;
